module.exports = __webpack_public_path__ + "img/service-setting-item1.8a7d89b4.png";